import React from 'react'
import Popup from '@components/popups/basic-modal'
import { Formik, Form, Field } from 'formik'
import { phoneNumberAutomasking, phoneHide } from '@helpers/utility'
// import { numberMask } from "@helpers/inputmask";
import style from '../index.module.scss'
import Icons from '@components/icons'
export default class extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false,
      contact_phone: '',
      submitting: false,
      otpSubmitting: false,
      otpValue: '',
      otpError: false
    }
  }
  getUserDetails () {
    const data = { ...this.state.user }
    var formated = data.contact_phone.toString().replace(/\D/g, '')
    let contact_phone = ''
    if (formated.length === 11) {
      contact_phone = formated.substr(1)
    } else {
      contact_phone = formated
    }
    data.contact_phone = phoneNumberAutomasking(contact_phone)

    return data
  }
  async handleResend () {
    const payload = {}
    payload.data = this.getUserDetails()
    await this.props.onResendtOtp(payload)
    this.setState({ otpValue: '' })
  }
  async handleOtpOnCall () {
    const payload = { query: { otpbycall: 1 } }
    payload.data = this.getUserDetails()
    await this.props.onResendtOtp(payload)
    this.setState({ otpValue: '' })
  }
  async handleOtpSubmit (values, { resetForm }) {
    await this.props.clearApiError()
    if (values.txt_otp && values.txt_otp.length) {
      this.setState({ otpError: false })
      const payload = this.getUserDetails()
      payload.otp = values.txt_otp
      payload.editMob = true
      payload.otpErr = false
      this.setState({ otpSubmitting: true })
      await this.props.verifyOtp(payload)
      this.setState({ otpSubmitting: false })
      if (this.props.apiError) {
        this.setState({ otpValue: '' })
      }
    } else {
      this.setState({ otpError: true })
    }
  }

  handleCancel (values, { resetForm }) {
    this.closeModal(true, resetForm)
    this.setState({ otpPage: false })
  }
  closeModal () {
    this.props.close()
  }
  reset (resetForm) {
    resetForm({ txt_phone: '' })
  }

  componentDidMount () {
    if (this.props.user) {
      this.setState({ user: this.props.user })
    }
  }

  render () {
    return (
      <Popup
        id="modalPhoneVerify3"
        open={this.props.open}
        title=""
        onCancel={this.props.close}
        type='small'
        modalBackdropClicked={this.closeModal.bind(this)}
        hideHeader={true}
      >
        <div className="modal-header d-block border-0 position-relative justify-content-center pb-15 pl-0 pr-0">
          <div className="mb-0">
            <div className="text-center mb-5">
              <img alt="" className="mb-20" src="https://dufzo4epsnvlh.cloudfront.net/image/icon-new/verify-icon.svg" />
              <h2 className="mb-10 fz-24">Enter verification code</h2>
            </div>
            <p className="text-center mb-0">A 4 digit code has been sent to {this.state.user && this.state.user.contact_phone ? `+1 ${phoneHide(this.state.user.contact_phone)}` : ''}
            </p>
          </div>
        </div>
        {this.props.apiError
          ? <div className="alert-danger border border-danger rounded text-center fz-12 py-5">{this.props.apiError}</div>
          : null}
        <Formik
          validateOnBlur={false}
          validateOnChange={false}
          enableReinitialize
          initialValues={{
            txt_otp: this.state.otpValue ? this.state.otpValue : ''
          }}
          onReset={this.handleCancel.bind(this)}
          onSubmit={this.handleOtpSubmit.bind(this)}
          render={({ values, setFieldValue, resetForm }) => {
            return (
              <Form>
                <button type="reset" className={'close remove-modal-close'}>
                  <span aria-hidden="true">×</span>
                </button>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label className="d-block text-center">
                        {this.state.otpError
                          ? <span className="form-error">Required</span>
                          : null}
                      </label>
                      <Field
                        className="form-control form-control-lg"
                        type="text"
                        name="txt_otp"
                        maxLength={4}
                        value={values.txt_otp}
                        placeholder="Enter verification code"
                        onChange={(e) => {
                          setFieldValue('txt_otp', e.target.value)
                          this.setState({ otpError: false })
                        }}
                      />
                      <div className="text-center mt-10">
                        <div className={`${style['receive-code']}`}>
                                                    Didn't receive the code ?
                          <button type="button" onClick={this.handleResend.bind(this)} className={`border-0 ${style['undo-btn']}`}><i className={`${style['icons-undo']}`}><Icons name="undo" /></i>Resend Code</button>
                          <button type="button" onClick={this.handleOtpOnCall.bind(this)} className={`border-0 ${style['undo-btn']}`}><i className={`${style['icons-undo']}`}><Icons name="undo" /></i>OTP on call</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <footer className="d-block mt-10">
                  <button type="submit"
                    disabled={this.state.otpSubmitting}
                    className={'btn btn-primary btn-xl btn-block border-0 d-block'}
                    id="get-paid" > SUBMIT
                    {this.state.otpSubmitting &&
                                            <i className="btn-icon top-minus-2">
                                              <img className="spinner" src="https://dufzo4epsnvlh.cloudfront.net/image/default.svg" alt="" />
                                            </i>
                    }
                  </button>
                </footer>
              </Form>
            )
          }}
        />
      </Popup>
    )
  }
}
